import {
  buildPath,
  buildTemplatePath,
  CloseButton,
  Dialog,
  Grid,
  handleClose,
  Page,
  
  PageRoute,
  Typography,
  useParams,
  Stack,
} from "@compass/core";
import "moment-timezone";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const routeName = "homelessDefinition";

class Params {
  languageId: number = 1;
}

export const homelessDefinitionPageRoute: PageRoute<Params> = {
  handle: "Homeless Definition",
  templatePath: buildTemplatePath(routeName, Params),
  getPath: (params) => buildPath(routeName, params),
};

export const HomelessDefinitionPage = () => {
  const navigate = useNavigate();
  const { params } = useParams(routeName, Params);

  useEffect(() => {}, []);

  const pageHeader = (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Typography variant="inherit">
        {params.languageId === 1 ? "Defining Homeless" : "Definición de personas sin hogar"}
      </Typography>

      <CloseButton />
    </Stack>
  );

  const pageBody = (
    <Grid container spacing="sm">
      <Grid item xs={12}>
        <Typography>
          {params.languageId === 1
            ? "The McKinney-Vento Act defines homeless children as “individuals who lack a fixed, regular, and adequate nighttime residence.” The act provides examples of children who would fall under this definition:"
            : "La Ley McKinney-Vento define a los niños sin hogar como “individuos que carecen de una residencia nocturna fija, regular y adecuada. La Ley provee ejemplos de niños que estarían bajo esta definición:"}
        </Typography>
      </Grid>
      {params.languageId === 1 && (
        <Grid item xs={12}>
          <ul>
            <li>Children and youth sharing housing due to loss of housing, economic hardship, or a similar reason.</li>
            <li>
              Children and youth living in motels, hotels, trailer parks, or campgrounds due to lack of alternative
              accommodations.
            </li>
            <li>Children and youth living in emergency or transitional shelters.</li>
            <li>Children and youth abandoned in hospitals.</li>
            <li>Children and youth awaiting foster care placement.</li>
            <li>
              Children and youth whose primary nighttime residence is not ordinarily used as a regular sleeping
              accommodations.
            </li>
            <li>
              Children and youth living in cars, parks, public spaces, abandoned buildings, substandard housing, bus or
              train stations park benches, etc.
            </li>
          </ul>
        </Grid>
      )}
      {params.languageId === 2 && (
        <Grid item xs={12}>
          <ul>
            <li>
              Niños y jóvenes que comparten la vivienda debido a la perdida de vivienda, dificultades económicas o una
              razón similar.
            </li>
            <li>
              Niños y jóvenes que viven en moteles, hoteles, parques de caravanas o lugares de campamento debido a la
              falta de alojamiento alternativo.
            </li>
            <li>Niños y jóvenes que viven en refugios de emergencia o transición.</li>
            <li>Niños y jóvenes abandonados en hospitales.</li>
            <li>Niños y jóvenes en espera de colocación en hogares de crianza.</li>
            <li>
              Los niños y jóvenes cuya residencia nocturna principal no se utiliza habitualmente como alojamiento para
              dormir (por ejemplo, bancos de parques, etc).
            </li>
            <li>
              Niños y jóvenes que viven en automóviles, parques, espacios públicos, edificios abandonados, viviendas de
              baja calidad, estaciones de autobús tren.
            </li>
          </ul>
        </Grid>
      )}
    </Grid>
  );

  return (
    <Dialog
      isForm
      open={true}
      onClose={() => handleClose(navigate)}
      maxWidth="md"
      header={pageHeader}
      content={pageBody}
    />
  );
};
